module.exports = __webpack_public_path__ + "img/try_2.c2cd1713.png";